import { black, gray } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const listForm = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
});

export const contentContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});

export const createBtn = style({
  marginTop: space.s16,
  width: 'fit-content',
  marginLeft: 'auto',
});

export const expandableGroup = style({
  display: 'flex',
  flexDirection: 'column',
  marginTop: space.s16,
  gap: space.s12,
});

export const highlightValueContainer = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s8,
  marginBottom: space.s12,
});

export const highlightValueInputContainer = style({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const divider = style({
  height: 1,
  width: '100%',
  marginBottom: space.s12,
  backgroundColor: themeVars.container.border.default,
});

export const addHighlightButton = style({
  marginTop: space.s12,
});

export const regexInput = style({
  marginTop: space.s12,
});

export const colorsContainer = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const colorPickerContainer = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s8,
  flexWrap: 'wrap',
});

export const colorPickerLabel = style({
  color: themeVars.controls.foreground.label,
  ...typography.labelMd,
});

export const group = style({
  padding: `${space.s12}px ${space.s16}px`,
  borderRadius: space.s16,
  backgroundColor: `light-dark(${gray[100]}, ${black[700]})`,
});

export const expandableSwitchGroupLabel = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
  cursor: 'pointer',
  ...typography.titleMd,
});

export const filterInput = style({
  marginBottom: space.s4,
});
